module.exports = __webpack_public_path__ + "img/member_bottom01.d82e6ae9.png";